<script setup>
import { onMounted, onUnmounted, reactive } from "vue";
import { getIsAgreeProtocol, agreeProtocolByTuid } from "@/api/teachinfo";

const reminder = reactive({
  dialog: false,
  progress: 100,
  seconds: 30,
});

let timer = null;
let timer1 = null;

function clearTimers() {
  if (timer) clearInterval(timer);
  if (timer1) clearInterval(timer1);
  timer = null;
  timer1 = null;
}

function countdown() {
  clearTimers();
  reminder.seconds = 30;
  reminder.progress = 100;
  timer = setInterval(() => {
    reminder.seconds -= 1;
    if (reminder.seconds <= 0) {
      reminder.seconds = 0;
      reminder.progress = 0;
      clearTimers();
    }
  }, 1000);
  timer1 = setInterval(() => {
    reminder.progress -= 100 / 150;
  }, 200);
}

function agreeProtocol() {
  if (reminder.seconds !== 0) return;
  reminder.dialog = false;
  clearTimers();
  agreeProtocolByTuid().catch(() => {});
}

onMounted(() => {
  getIsAgreeProtocol()
    .then((res) => {
      if (res.data?.ErrorCode === 0 && res.data.Body === false) {
        reminder.dialog = true;
        countdown();
      }
    })
    .catch(() => {});
});

onUnmounted(() => {
  clearTimers();
});
</script>

<template>
  <el-dialog
    v-model="reminder.dialog"
    width="940px"
    align-center
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    class="protocol-reminder-dialog"
  >
    <div class="protocol-head">
      <h3 class="protocol-title">WARNING AND IMPORTANT REMINDER</h3>
      <el-progress
        type="circle"
        :percentage="Math.max(0, Math.min(100, reminder.progress))"
        :width="45"
        :stroke-width="3"
        color="#ee344c"
        :format="() => `${reminder.seconds}s`"
      />
    </div>
    <div class="protocol-body">
      <p>
        Please be warned that while you are at work and accessing ClassIn, Tutor Page, and company’s
        system and network, your browsing behavior, sites being visited and videos being watched are
        monitored and captured by the company.These class recordings are for quality check purpose. You
        are obliged to perform as a professional teacher. Your personal life should not get involved.
        And the company would not use it for other purpose.
      </p>
      <p class="danger">
        During teaching hours, all websites not related to teaching must be closed. You are prohibited
        from:<br />
        Listening, watching, or viewing pornographic sites and adult materials.<br />
        Discussing, engaging, or viewing sites and materials related to drugs, liquor, gambling,
        violence, pornography, race, religion, and politics with the students.
      </p>
      <p>
        Commission of the above acts and similar circumstances that are unacceptable in a teaching and
        working situation shall immediately entitle the company to:<br />
        a.) Terminate your services; and/or<br />
        b.) File suit in the appropriate court for damages; and/or<br />
        c.) File suit in the appropriate court for any and all causes of action available to it.
      </p>
      <p>
        <strong>User compliance</strong><br />
        I understand and will abide by this Warning and Reminder. I further understand that should I
        commit any violation as above-mentioned, my services may outrightly be terminated, and/or
        appropriate legal action may be taken.
      </p>
    </div>
    <div class="protocol-footer">
      <button
        type="button"
        class="agree-btn"
        :disabled="reminder.seconds !== 0"
        @click="agreeProtocol"
      >
        I Agree
      </button>
    </div>
  </el-dialog>
</template>

<style scoped lang="scss">
.protocol-head {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 8px;
}

.protocol-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #32397a;
  text-align: center;
}

.protocol-body {
  color: #32397a;
  line-height: 22px;
  font-size: 14px;
  max-height: 55vh;
  overflow: auto;
  padding-right: 4px;

  p {
    margin: 0 0 12px;
  }

  .danger {
    color: #ee344c;
  }
}

.protocol-footer {
  display: flex;
  justify-content: center;
  padding-top: 8px;
}

.agree-btn {
  height: 30px;
  min-width: 100px;
  padding: 0 20px;
  border: none;
  border-radius: 5px;
  background: #ee344c;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  box-shadow: none;

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    opacity: 0.92;
  }
}
</style>

<style lang="scss">
.protocol-reminder-dialog.el-dialog {
  border-radius: 8px;
}

.protocol-reminder-dialog .el-dialog__header {
  display: none;
}

.protocol-reminder-dialog .el-dialog__body {
  padding: 20px 24px 16px;
}
</style>
